var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSmileyface(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.95,114.04c-5.87,0-10.63,4.76-10.63,10.63c0,5.87,4.76,10.63,10.63,10.63s10.63-4.76,10.63-10.63 C163.58,118.8,158.82,114.04,152.95,114.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.83,152.27c-0.69,0-1.38,0.26-1.99,0.43c-5.85,1.68-14.93,2.71-21.38,2.71s-15.52-1.03-21.38-2.71 c-0.62-0.18-1.31-0.43-2-0.43c-1.91,0-3.47,1.55-3.47,3.47c0,0.95,0.39,1.81,1.01,2.44l0,0l0.01,0.01c0,0,0,0,0.01,0.01 c0.08,0.09,9.39,10.07,25.82,10.07c16.43,0,25.74-9.98,25.82-10.07c0,0,0-0.01,0.01-0.01l0.01-0.01v0c0.62-0.63,1-1.49,1-2.44 C152.3,153.82,150.75,152.27,148.83,152.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.39,124.67c0-5.87-4.76-10.63-10.63-10.63s-10.63,4.76-10.63,10.63c0,5.87,4.76,10.63,10.63,10.63 S108.39,130.54,108.39,124.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.46,2.99C58.26,2.99,3.78,57.47,3.78,124.67c0,67.2,54.48,121.68,121.68,121.68 s121.68-54.48,121.68-121.68C247.14,57.47,192.66,2.99,125.46,2.99z M125.46,186.25c-34.01,0-61.59-27.57-61.59-61.58 s27.57-61.59,61.59-61.59s61.58,27.57,61.58,61.59S159.47,186.25,125.46,186.25z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmileyface);
export default __webpack_public_path__ + "static/media/ic_smileyface.495fdbb65d831356be1b83026f77f2a1.svg";
export { ForwardRef as ReactComponent };